import React, { useEffect, useState } from 'react'
import { InputCompo } from '../../../Components/InputCompo/InputCompo'
import * as Yup from 'yup';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useFormikContext } from 'formik';
import { useNavigate } from 'react-router-dom';
const Finance = ({ values, setFieldValue, setAdvPostData, tabs, setTabs }) => {

    const navigate = useNavigate()

    const TaxExemption = [
        { name: 'tax_12a', label: '12A/ 12AA/ 12AB' },
        { name: 'tax_10c', label: '10(23C)' },
        // { name: '', label: 'None' },
    ]
    const TaxDeduction = [
        { name: 'tax_80g', label: '80G' },
        { name: 'tax_35a', label: '35 (1)(ii)' },
        { name: 'tax_35b', label: '35 (1)(iii)' },
    ]
    const CSRRegistration = [
        { name: 'csr_registration', label: 'Yes' },
    ]
    const SSEListing = [
        { name: 'sse_listing', label: 'Yes' },
    ]
    const FCRA = [
        { name: 'fcra', label: 'Yes' },
    ]
    const SlabsOfExpenditure = [
        { name: 'slabs_exp_upto_10lakh', label: 'Upto INR 10 lakh' },
        { name: 'slabs_exp_upto_50lakh', label: 'INR 10 lakh - INR 50 lakh' },
        { name: 'slabs_exp_upto_1cr', label: 'INR 50 lakh - INR 1 Cr' },
        { name: 'slabs_exp_upto_5cr', label: 'INR 1 Cr - INR 5 Cr' },
        { name: 'slabs_exp_upto_10cr', label: 'INR 5 Cr - INR 10 Cr' },
        { name: 'slabs_exp_upto_20cr', label: 'INR 10 Cr - INR 20 Cr' },
        { name: 'slabs_exp_upto_50cr', label: 'INR 20 Cr - INR 50 Cr' },
        { name: 'slabs_exp_above_50cr', label: 'Above INR 50 Cr' },
    ]
    const SlabsOfAssets = [
        { name: 'slabs_asst_upto_50lakh', label: 'Upto INR 50 lakh' },
        { name: 'slabs_asst_upto_1cr', label: 'INR 50 lakh - INR 1 Cr' },
        { name: 'slabs_asst_upto_5cr', label: 'INR 1 Cr - INR 5 Cr' },
        { name: 'slabs_asst_upto_10cr', label: 'INR 5 Cr - INR 10 Cr' },
        { name: 'slabs_asst_upto_20cr', label: 'INR 10 Cr - INR 20 Cr' },
        { name: 'slabs_asst_upto_50cr', label: 'INR 20 Cr - INR 50 Cr' },
        { name: 'slabs_asst_upto_100cr', label: 'INR 50 Cr - INR 100 Cr' },
        { name: 'slabs_asst_above_100cr', label: 'Above INR 100 Cr' },
    ]
    const SourceofFunding = [
        // { name: '', label: 'Self - Generated Revenue' },
        { name: 'insti_domestic', label: 'Institutional - Domestic' },
        { name: 'public_retail_domestic', label: 'Public (Retail) - Domestic' },
        { name: 'public_hni_domestic', label: 'Public (HNI) - Domestic' },
        { name: 'corp_domestic', label: 'Corporate - Domestic' },
        { name: 'gov_domestic', label: 'Government - Domestic' },
        { name: 'insti_foreign', label: 'Institutional - Foreign' },
        { name: 'public_retail_foreign', label: 'Public (Retail) - Foreign' },
        { name: 'public_hni_foreign', label: 'Public (HNI) - Foreign' },
        { name: 'corporate_foreign', label: 'Corporate - Foreign' },
        { name: 'gov_foreign', label: 'Government - Foreign' },
        { name: 'un', label: 'UN' },
    ]
    const searchParams = new URLSearchParams(window.location.search);
    const advancedSearchMiniTab = searchParams.get('advancedSearchMiniTab');
    const miniTab = JSON.parse(decodeURIComponent(advancedSearchMiniTab))

    const viewTabs = (name) => {
        const existingMiniTab = searchParams.get('advancedSearchTab');
        const AdvancedTab = existingMiniTab ? `&advancedSearchTab=${encodeURIComponent(existingMiniTab)}` : '';
        const AdvancedSearchUrl = searchParams.get('AdvancedSearch');
        const AdvancedSearchUrlQuery = AdvancedSearchUrl ? `&AdvancedSearch=${encodeURIComponent(AdvancedSearchUrl)}` : '';

        if (miniTab?.[name]) {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: false }))}${AdvancedTab}${AdvancedSearchUrlQuery}`, { replace: true });
        } else {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: true }))}${AdvancedTab}${AdvancedSearchUrlQuery}`, { replace: true });
        }
    }

    useEffect(() => {
        if (advancedSearchMiniTab) {
            setTabs(miniTab)
        }
    }, [advancedSearchMiniTab])



    const advancedSearchUrlQuery = searchParams.get('AdvancedSearch');



    const DisplayFormikValues = () => {
        const { values, errors } = useFormikContext();
        return null; // You can return JSX or null if you just want to log the values
    };




    useEffect(() => {
        if (advancedSearchUrlQuery) {
            try {
                const parsedData = JSON.parse(decodeURIComponent(advancedSearchUrlQuery));
                // reCallApi(parsedData);
                setAdvPostData(parsedData);
            } catch (error) {
                console.error("Error parsing search query:", error);
            }
        }
    }, [advancedSearchUrlQuery]);


    return (
        <>

            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='Tax Exemption type' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Tax Exemption type')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["Tax Exemption type"] &&
                    <div className="w-[100%]">

                        {TaxExemption.map((ele) => {
                            const fieldName = ele.name
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={() =>
                                            setFieldValue(fieldName, !values[fieldName])
                                        }
                                        checked={!!values[fieldName]} // Ensure checkbox state is in sync
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                }
            </div >
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='Tax Deduction type' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Tax Deduction type')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["Tax Deduction type"] &&

                    <div className="w-[100%]">
                        {TaxDeduction.map((ele) => {
                            const fieldName = ele.name
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={() =>
                                            setFieldValue(fieldName, !values[fieldName])
                                        }
                                        checked={!!values[fieldName]} // Ensure checkbox state is in sync
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='FCRA Registration' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('FCRA Registration')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["FCRA Registration"] &&
                    <div className="w-[100%]">
                        {FCRA.map((ele, index) => {
                            // Generate unique field names to avoid conflicts
                            const fieldName = `${ele.name}_${index}`;
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            // Update the main `fcra` value based on the checked box
                                            if (isChecked) {
                                                setFieldValue('fcra', ele.label);
                                            } else {
                                                setFieldValue('fcra', ''); // Reset if unchecked
                                            }
                                        }}
                                        checked={values.fcra === ele.label}
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='CSR Registration' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('CSR Registration')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["CSR Registration"] && (
                    <div className="w-[100%]">
                        {CSRRegistration.map((ele, index) => {
                            // Generate unique field names to avoid conflicts
                            const fieldName = `${ele.name}_${index}`;
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            // Update the main `csr_registration` value based on the checked box
                                            if (isChecked) {
                                                setFieldValue('csr_registration', ele.label);
                                            } else {
                                                setFieldValue('csr_registration', ''); // Reset if unchecked
                                            }
                                        }}
                                        checked={values.csr_registration === ele.label}
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='SSE Listing' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('SSE Listing')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["SSE Listing"] &&
                    <div className="w-[100%]">
                        {SSEListing.map((ele, index) => {
                            // Generate unique field names to avoid conflicts
                            const fieldName = `${ele.name}_${index}`;
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            // Update the main `sse_listing` value based on the checked box
                                            if (isChecked) {
                                                setFieldValue('sse_listing', ele.label);
                                            } else {
                                                setFieldValue('sse_listing', ''); // Reset if unchecked
                                            }
                                        }}
                                        checked={values.sse_listing === ele.label}
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                }
            </div>

            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='Expenditure (annual)' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Expenditure (annual)')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["Expenditure (annual)"] && (
                    <div className="w-[100%]">
                        {SlabsOfExpenditure.map((ele) => {
                            const fieldName = ele.name;
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={() => {
                                            // Set the current field to true
                                            setFieldValue(fieldName, true);

                                            // Set all other fields to false
                                            SlabsOfExpenditure.forEach((otherEle) => {
                                                if (otherEle.name !== fieldName) {
                                                    setFieldValue(otherEle.name, false);
                                                }
                                            });
                                        }}
                                        checked={!!values[fieldName]}
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="radio" // Or type="radio" if you want radio buttons
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                )}
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='Assets' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Assets')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["Assets"] &&
                    <div className="w-[100%]">
                        {SlabsOfAssets.map((ele) => {
                            const fieldName = ele.name
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={() => {
                                            // Set the current field to true
                                            setFieldValue(fieldName, true);

                                            // Set all other fields to false
                                            SlabsOfAssets.forEach((otherEle) => {
                                                if (otherEle.name !== fieldName) {
                                                    setFieldValue(otherEle.name, false);
                                                }
                                            });
                                        }}
                                        checked={!!values[fieldName]} // Ensure checkbox state is in sync
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="radio"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='Source of Funding' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Source of Funding')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["Source of Funding"] &&
                    <div className="w-[100%]">
                        {SourceofFunding.map((ele) => {
                            const fieldName = ele.name
                            return (
                                <label
                                    className="flex mt-[16px] items-center space-x-2"
                                    key={fieldName}
                                >
                                    <InputCompo
                                        onChange={() =>
                                            setFieldValue(fieldName, !values[fieldName])
                                        }
                                        checked={!!values[fieldName]} // Ensure checkbox state is in sync
                                        name={fieldName}
                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                        type="checkbox"
                                    />
                                    <span className="text-black">{ele?.label}</span>
                                </label>
                            );
                        })}
                    </div>
                }
            </div>

            <DisplayFormikValues />


        </>
    )
}

export default Finance